<div class="tw-h-[100vh] tw-font-body nutra-push-bottomsheet tw-relative">
  <div class="tw-flex tw-gap-1 tw-items-center">
    <h1 class="tw-pt-4 tw-font-bold tw-text-500 tw-pl-4 tw-pb-2.5 tw-w-full">{{data?.bottomSheetData?.title}}</h1>
    <div class="tw-w-[36px] tw-aspect-square tw-flex-shrink-0 tw-flex tw-items-center">
      <img (click)="closeBottomSheet()" class="tw-w-[18px] tw-aspect-square tw-p-0.5 tw-bg-gray-80 tw-rounded-full tw-cursor-pointer" src="/assets/images/cancel-cross.png" />
    </div>
  </div>
  <!--  scroll container-->
  <div class="tw-h-full tw-overflow-y-auto tw-relative tw-pl-4" #contentContainer>
    <!--  daily dose and part of day-->
    <div class="tw-flex tw-items-center">
      <div class="tw-pr-3">
        @switch (data?.bottomSheetData?.margId) {
          @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.GLUTA) {
            <p i18n="@@oneCapsuleDaily" class="">1 capsule daily</p>
          }
          @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO) {
            <p i18n="@@oneSachetDaily">1 sachet daily</p>
          }
          @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.VITAL) {
            <p i18n="@@oneTabletDaily">1 tablet daily</p>
          }
          @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA) {
            <p i18n="@@oneCapsuleDaily">1 capsule daily</p>
          }
          @default {
            <p class="tw-text-teal-600 tw-text-300 tw-w-full tw-leading-4 tw-italic" i18n="@@oneCapsuleDaily">1 capsule daily</p>
          }
        }
      </div>
      @if (data?.bottomSheetData?.instructions[0]?.partOfDay?.toLowerCase()?.includes('morning')) {
        <div class="tw-flex tw-items-center tw-gap-1">
          <cs-icon class="tw-h-4 tw-w-4"
          [iconName]="'light_full'"></cs-icon>
          <span i18n="@@morning"> Morning </span>
        </div>
      }
      @if (data?.bottomSheetData?.instructions[0]?.partOfDay?.toLowerCase()?.includes('night')) {
        <div class="tw-flex tw-items-center tw-gap-1">
          <cs-icon class="tw-h-4 tw-w-4"
          [iconName]="'night_full'"></cs-icon>
          <span i18n="@@night"> Night </span>
        </div>
      }
    </div>
    <!--image slider-->
    <div class="tw-mt-4">
      @if (nutraSliderAllImages.length > 0) {
        <swiper
          [config]="swiperConfig">
          @for (object of nutraSliderAllImages; track $index; let first = $first; let last = $last;) {
            <div *swiperSlide>
              <div class="tw-h-auto tw-overflow-hidden tw-rounded-4 tw-bg-gray-100 tw-relative tw-mr-2">
                @if ($index === 0) {
                  <div
                    class="tw-absolute tw-top-2 tw-left-2 tw-bg-white tw-rounded-4 tw-px-1.5 tw-z-10">
                    <p class="tw-text-100">{{data?.bottomSheetData?.quantity}} {{data?.bottomSheetData?.quantityUnit}}</p>
                  </div>
                }
                <img [src]="object.url"
                  class="tw-h-auto tw-w-auto">
              </div>
            </div>
          }
        </swiper>
      }
    </div>
    <!--  contents  -->
    <div class="tw-mt-5">
      <!--    tabs  -->
      <div class="tw-sticky tw-top-0 tw-bg-white">
        <div class="tw-flex tw-text-300 tw-text-gray-400 tw-gap-6 tw-mb-5 tw-pb-2 tw-relative">
          <h2 [ngClass]="{'tw-text-teal-600 tw-font-bold': activeTab === 'description'}" (click)="scrollToSection('description')" #tabDescription i18n="@@description">Description</h2>
          <h2 [ngClass]="{'tw-text-teal-600 tw-font-bold': activeTab === 'ingredients'}" (click)="scrollToSection('ingredients')" #tabIngredients i18n="@@nutraPushIngredients">Ingredients</h2>
          <h2 [ngClass]="{'tw-text-teal-600 tw-font-bold': activeTab === 'howToUse'}" (click)="scrollToSection('howToUse')" #tabHowToUse i18n="@@howToUse"> How to use </h2>

          <!-- Track and Sliding indicator -->
          <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-1 tw-flex tw-items-center">
            <!-- Track -->
            <div class="tw-absolute tw-w-full tw-h-[1px] tw-bg-gray-200 tw-rounded-l-full"></div>
            <!-- Slider -->
            <div class="tw-absolute tw-h-[3px] tw-bg-teal-600 tw-transition-all tw-duration-300 tw-ease-in-out tw-rounded-full" [ngStyle]="getIndicatorStyles()"></div>
          </div>
        </div>
      </div>
      <!-- Descriptions -->
      <div id="description" #descriptionSection class="tw-pr-4 tw-pb-12">
        <p class="tw-text-300 tw-text-gray-500 tw-mb-4">{{data?.bottomSheetData?.description}}</p>
        @if (data?.bottomSheetData?.productHighlights?.length && data?.bottomSheetData?.productHighlights[0]?.image) {
          <div
            class="tw-flex tw-gap-2 tw-text-300">
            @for (highlight of data?.bottomSheetData?.productHighlights; track $index) {
              <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-2">
                <div class="tw-h-10 tw-w-10">
                  <img class="tw-h-full tw-w-full"
                    [src]="highlight?.image">
                </div>
                <p [innerHTML]="highlight?.description"></p>
              </div>
            }
          </div>
        }
      </div>
      <!--    Key Ingredients  -->
      @if (data?.bottomSheetData?.heroIngredients?.length && data?.bottomSheetData?.heroIngredients[0]?.image) {
        <div id="ingredients" #ingredientsSection
          class="tw-pb-12">
          <h1 class="tw-mb-4 tw-flex tw-gap-2 tw-items-center">
            <span class="tw-text-400 tw-text-gray-400" i18n="@@keyIngredients">Key Ingredients</span>
            <span class="tw-bg-gray-300 tw-inline-block tw-h-[1px] tw-flex-1"></span>
          </h1>
          <div class="tw-flex tw-flex-col tw-gap-6">
            @for (ingredient of data?.bottomSheetData?.heroIngredients; track $index) {
              <div class="tw-flex-1 tw-flex tw-gap-4 tw-pr-4">
                <div class="tw-h-16 tw-w-16">
                  <img class="tw-h-full tw-w-full"
                    [src]="ingredient?.image">
                </div>
                <div class="tw-flex-1 tw-flex tw-flex-col">
                  <h3 class="tw-text-300 tw-font-bold">{{ingredient?.name}}</h3>
                  <p [innerHTML]="ingredient?.description" class="tw-text-gray-500 tw-text-300 tw-w-44"></p>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <!--      Instructions -->
      <div id="howToUse" #howToUseSection class="">
        <h1 class="tw-mb-4 tw-flex tw-gap-2 tw-items-center">
          <span class="tw-text-400 tw-text-gray-400" i18n="@@instructions">Instructions</span>
          <span class="tw-bg-gray-300 tw-inline-block tw-h-[1px] tw-flex-1"></span>
        </h1>

        <div class="tw-pr-4">
          <img class="tw-h-full tw-w-full tw-rounded-4 tw-mb-64"
            [src]="userLanguage === 'hi' ? data?.bannerData?.instructions?.hi : data?.bannerData?.instructions?.en">
        </div>
      </div>
      <!--      CTA  -->
      <div class="tw-bg-gradient-light-teal-to-white tw-h-32 tw-w-full tw-fixed tw-bottom-0 tw-inset-x-0 tw-shadow-z11 tw-px-4 tw-pt-2 tw-pb-6 tw-space-y-2">
        <div class="tw-flex tw-gap-2 tw-pb-2 tw-items-center">
          <img src="https://cdn.cureskin.com/app/img/bulb.gif" alt="bulb" class="tw-w-8 tw-aspect-square tw-mix-blend-multiply" />
          @switch (data?.bottomSheetData?.margId) {
            @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.GLUTA) {
              <p class="tw-text-teal-600 tw-text-300 tw-w-full tw-leading-4 tw-italic" i18n="@@glutaPushBottomSheetCTAcontainerText"><b>80%</b> users who used Gluta felt an <b>improvement in mood & confidence</b></p>
            }
            @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO) {
              <p class="tw-text-teal-600 tw-text-300 tw-w-full tw-leading-4 tw-italic" i18n="@@myoPushBottomSheetCTAcontainerText"><b>90% users repurchased</b> the Myo-inositol Powder due to it’s visible, trusted results</p>
            }
            @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.VITAL) {
              <p class="tw-text-teal-600 tw-text-300 tw-w-full tw-leading-4 tw-italic" i18n="@@vitalPushBottomSheetCTAcontainerText"><b>90% users repurchased</b> the Vital Boost tablets due to it’s visible, trusted results</p>
            }
            @case (appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA) {
              <p class="tw-text-teal-600 tw-text-300 tw-w-full tw-leading-4 tw-italic" i18n="@@omegaPushBottomSheetCTAcontainerText"><b>90% users repurchased</b> the Omega Capsules due to it’s visible, trusted results</p>
            }
            @default {
              <p class="tw-text-teal-600 tw-text-300 tw-w-full tw-leading-4 tw-italic" i18n="@@glutaPushBottomSheetCTAcontainerText"><b>80%</b> users who used Gluta felt an <b>improvement in mood & confidence</b></p>
            }
          }
        </div>
        <div class="tw-px-6 tw-py-2 tw-bg-teal-600 tw-rounded-3 tw-text-white tw-text-300 tw-font-bold tw-text-center"
          (click)="buyNowHandler()"
          >
          <span i18n="@@buyNow">Buy Now</span> &#64; {{data?.bottomSheetData?.price}}
        </div>
      </div>
    </div>
  </div>
</div>
